import React from 'react';
import BoletoIcon from '../../../icons/payment/BoletoIcon';
import { formatCurrency } from '../../../../utils/formatting';
import type { BoletoHeaderProps } from '../types/boleto-payment.types';

const BoletoHeader: React.FC<BoletoHeaderProps> = ({ customerName, totalAmount }) => {
  return (
    <div className="text-center mb-8">
      <BoletoIcon className="w-16 h-16 mx-auto text-primary mb-4" />
      <h2 className="text-2xl sm:text-3xl font-bold text-primary mb-2">
        Seu Boleto Foi Gerado!
      </h2>
      <p className="text-text-secondary dark:text-gray-300">
        Olá, {customerName}! Seu pedido no valor de <strong className="text-text-primary dark:text-gray-100">{formatCurrency(totalAmount)}</strong> está quase confirmado.
      </p>
      <p className="text-text-secondary dark:text-gray-300 mt-1">
        Realize o pagamento do boleto abaixo para concluir sua compra.
      </p>
    </div>
  );
};

export default BoletoHeader; 